export enum CommentActionTypes {
    API_RESPONSE_SUCCESS = "@@comments/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@comments/API_RESPONSE_ERROR",
    CREATE_COMMENTS = "@@comments/CREATE_COMMENTS",
    EDIT_COMMENTS = "@@comments/EDIT_COMMENTS",
    DELETE_COMMENTS = "@@comments/DELETE_COMMENTS",
    GET_COMMENTS = "@@comments/GET_COMMENTS",
  }
  